module.exports = __webpack_public_path__ + "img/khandevaneh.d5da140.png";